var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { MenuItem } from '../menuItem';
import { dayjs } from './dayjs';
var displayName = 'ChangeCurrentMonthOrYear';
export var ChangeCurrentMonthOrYear = function (_a) {
    var activeDescendant = _a.activeDescendant, classes = _a.classes, currentDate = _a.currentDate, _b = _a.maxSelectableYear, maxSelectableYear = _b === void 0 ? dayjs().add(20, 'year').startOf('year').get('year') : _b, _c = _a.minSelectableYear, minSelectableYear = _c === void 0 ? dayjs().subtract(20, 'year').startOf('year').get('year') : _c, onCurrentDateChange = _a.onCurrentDateChange, translate = _a.translate, type = _a.type;
    var _d = __read(React.useState(null), 2), listRef = _d[0], setListRef = _d[1];
    // renderable memos
    var renderableSelectableMonths = React.useMemo(function () {
        var out = [];
        if (type === 'month') {
            var startMonth = dayjs(currentDate).startOf('year');
            var endMonth = startMonth.endOf('year').add(1, 'month');
            var iter = dayjs(startMonth.toISOString());
            var currentMonth = dayjs(currentDate).startOf('month').get('month');
            var _loop_1 = function () {
                var iterISO = iter.toISOString();
                var onMonthClick = function () { return onCurrentDateChange(iterISO); };
                var menuItemLabel = translate('datepicker.monthName', {
                    date: iterISO,
                });
                var selected = iter.get('month') === currentMonth;
                out.push(_jsx(MenuItem, { "data-selected": selected.toString(), id: "datepicker-month-".concat(iter.get('month').toString()), label: menuItemLabel, onClick: onMonthClick, selected: selected, selectType: "single" }, iterISO));
                iter = iter.add(1, 'month');
            };
            while (endMonth.diff(iter, 'month') > 0) {
                _loop_1();
            }
        }
        else {
            // user wants to select the year instead of the month
            var iter = dayjs().set('year', minSelectableYear).startOf('year');
            var currentYear = dayjs(currentDate).startOf('year').get('year');
            var currentMonth_1 = dayjs(currentDate).startOf('month').get('month');
            var _loop_2 = function () {
                var iterISO = iter.toISOString();
                var onYearClick = function () { return onCurrentDateChange(dayjs(iterISO).set('month', currentMonth_1).toISOString()); };
                var menuItemLabel = translate('datepicker.yearName', { date: iterISO });
                var selected = iter.get('year') === currentYear;
                out.push(_jsx(MenuItem, { "data-selected": selected.toString(), label: menuItemLabel, id: "datepicker-year-".concat(iter.get('year').toString()), onClick: onYearClick, selected: selected, selectType: "single" }, iterISO));
                iter = iter.add(1, 'year');
            };
            while (iter.get('year') <= maxSelectableYear) {
                _loop_2();
            }
        }
        return out;
    }, [currentDate, maxSelectableYear, minSelectableYear, onCurrentDateChange, translate, type]);
    // effects
    React.useEffect(function () {
        // since this will be a singleton component, guard against an invalid root element
        if (!listRef || listRef.getAttribute('data-type') !== type)
            return;
        var selectedItem = listRef.querySelector('[data-selected="true"]');
        if (!selectedItem)
            return;
        // Need to scroll to the currently-selected item, but only when the component mounts
        var _a = selectedItem.getBoundingClientRect(), height = _a.height, top = _a.top;
        var parentTop = listRef.getBoundingClientRect().top;
        if (top > parentTop)
            listRef.scrollTo({ top: listRef.scrollTop + (top - parentTop - height) });
        else if (top < parentTop)
            listRef.scrollTo({ top: listRef.scrollTop - (parentTop - top) + height });
    }, [listRef, type]);
    return (_jsx("ul", __assign({ "aria-activedescendant": activeDescendant, className: classes.changeCurrentMonthOrYear, "data-type": type, ref: setListRef, role: "menu", tabIndex: 0 }, { children: renderableSelectableMonths })));
};
ChangeCurrentMonthOrYear.displayName = displayName;
